import React from 'react';

interface LabShellProps {
    children: React.ReactNode;
    pageTitle?: string;
}

export const LabShell: React.FC<LabShellProps> = ({ children }) => (
    <>
        {children}
    </>
);

export default LabShell;
